import React, { useEffect, useRef, useState, ChangeEvent, forwardRef } from 'react';

export interface InputProps {
	id: string;
	value?: string;
	name?: string;
	type?: string;
	placeholder?: string;
	isInvalid?: boolean;
	disabled?: boolean;
	onBlur(): void;
	onChange(value: string): void;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
	{ id, value, name, type = 'text', placeholder, isInvalid, disabled, onBlur, onChange },
	ref
) {
	const [inputValue, setInputValue] = useState(value || '');
	const isInitialRender = useRef(true);

	useEffect(() => {
		if (isInitialRender.current) {
			isInitialRender.current = false;
			return;
		}
		const inputTimer = setTimeout(() => {
			onChange(inputValue);
		}, 500);

		return () => clearTimeout(inputTimer);
	}, [inputValue]);

	const handleChangeInputValue = (item: ChangeEvent<HTMLInputElement>) => {
		const { target } = item;

		setInputValue(target.value);
	};

	return (
		<input
			ref={ref}
			className={`block px-2 w-full h-8 border rounded border-gray-300 text-[14px] leading-7 text-black bg-white shadow ${
				isInvalid && 'focus:ring-2 focus:ring-offset-1 focus:ring-red-300 !border-red-500'
			} ${disabled ? '!bg-gray-100 !text-gray-400 cursor-not-allowed' : ''}`}
			id={id}
			name={name}
			type={type}
			placeholder={placeholder}
			value={inputValue}
			disabled={disabled}
			onBlur={onBlur}
			onChange={handleChangeInputValue}
		/>
	);
});
